import { apiCall } from "./../imports"

export default {

    gets() {
        return apiCall('get', "management/portfolios")
    },

    get(portfolioID) {
        return apiCall('get', `management/portfolios/${portfolioID}`);
    },

    create(data) {
        return apiCall('post', `management/portfolios`, data)
    },

    update(portfolioID, data) {
        return apiCall('post', `management/portfolios/${portfolioID}/update`, data)
    },

    delete(portfolioID) {
        return apiCall('delete', `management/portfolios/${portfolioID}`)
    },

    deleteImage(portfolioID, imageID) {
        return apiCall('delete', `management/portfolios/${portfolioID}/images/${imageID}`);
    }
}